import { render } from "./ProgrammeExceptionTimeForm.vue?vue&type=template&id=622b8f18"
import script from "./ProgrammeExceptionTimeForm.vue?vue&type=script&lang=js"
export * from "./ProgrammeExceptionTimeForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/amatra-frontend-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__